import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckMark = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18.3337 5.5L8.25032 15.5833L3.66699 11",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCheckMark;
